import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Route} from 'react-router-dom';

import {fetchRecord, clearRecord} from './record.actions';
import * as selectors from './record.selectors';
import {setPageTitle, setBreadcrumbs} from '../../application.actions';

import RecordContainer from './RecordContainer';
import RecordUploadContainer from './RecordUploadContainer';

class RecordRoute extends React.Component {
  componentWillMount() {
    const {actions, match: {params: {periodId, recordId}}} = this.props;
    actions.fetchRecord(periodId, recordId);
  }

  componentWillUnmount() {
    this.props.actions.clearRecord()
  }

  componentWillUpdate(nextProps) {
    const {actions, record, period} = nextProps;
    actions.setBreadcrumbs([
      {to: '/', title: 'Periods'},
      {to: `/period/${period.id}`, title: period.description},
      {active: true, title: record.name}
    ])
  }

  render() {
    return (
      <React.Fragment>
        <Route path="/records/:periodId/:recordId/uploads" component={RecordUploadContainer}/>
        <Route exact path="/records/:periodId/:recordId" component={RecordContainer}/>
        <Route exact path="/records/:periodId/:recordId/irr/:irrSampleId" component={RecordContainer}/>
      </React.Fragment>
    );
  }
}

RecordRoute.propTypes = {};

export default connect(
  (state) => ({
    period: selectors.period(state),
    record: selectors.record(state)
  }),
  dispatch => ({
    actions: bindActionCreators({fetchRecord, clearRecord, setPageTitle, setBreadcrumbs}, dispatch)
  })
)(RecordRoute);



// WEBPACK FOOTER //
// ./src/modules/record/index.js